import { Button } from "antd";
import styled from "styled-components";

export const StyledCOMConfirmButton = styled(Button)`
    height: 50px;
    border-radius: 50px;
    width: 100%;
    font-size: 16px;
    background-color: #49aa19;
`;

export const StyledCOMCancelButton = styled(Button)`
    text-decoration: underline;
    margin-top: 16px;
    width: 100%;
    text-underline-offset: 3px;
`;
